module.exports = {
      id: "carteira-sem-transacoes-usage",
      viewBox: "0 0 201 167",
      url: __webpack_public_path__ + "img/icons.09862bea.svg#carteira-sem-transacoes",
      toString: function () {
        return this.url;
      }
    }